import { render, staticRenderFns } from "./ValueJson.vue?vue&type=template&id=4f94f57b&"
import script from "./ValueJson.vue?vue&type=script&lang=js&"
export * from "./ValueJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports